import { FC, ReactNode } from 'react';

import { Box, BoxProps, rem, Text } from '@bonusly/design-system';

type UserNavFooterLinkProps = BoxProps & {
	children: ReactNode;
	href: string;
};

export const UserNavFooterLink: FC<UserNavFooterLinkProps> = ({ children, href, ...props }) => (
	<Box as="a" href={href} display="block" w="100%" px={rem(12)} py={0} {...props}>
		<Text color="text.softest" fontSize={50} fontWeight="normal" _hover={{ textDecoration: 'underline' }}>
			{children}
		</Text>
	</Box>
);
